/**
 * Text component constructor
 * @constructor shared.stage.components.Text
 */
 fx.ns("shared.stage.components", class Text extends shared.stage.base.BaseComponent{
    
	constructor(component, model, parent, manual, commands)
	{
        super(component, model, parent, commands, manual);
        
        this.movableWhenActive = false;

        this._fontService = fx.service("FontLoader", this.model.fonts);
        this._loadingFonts = [];
        this._textOutside = false;
        this._warning = false;

        //this.contextMenu = "default";

        this._acceptedSize = {width:0, height:0};

        this._loadFontTries = 0;

        // allows to make users click 2 times on Text before to make it fully editable
        this._preactivate = false;

        this.lockOnlostBorder = true;
    }
    
 
    /**************** Getters ****************/

    
    get MARGINS() { 
        return 10; 
    }
    
    get empty()
    {
        return this._textEditor && this._textEditor.empty;
    }
 
    get hasWarning()
    {
        return this._warning;
    }

    get font()
    {
        if (!this._textEditor && !this.data)
            return "";   
            
        let font;

        if (this._textEditor.fontFamily)
        {
            let fonts = this._textEditor.fontFamily.split(',');
            let fontName = fonts[0].trim().replace(/"/g, '');
            font = this.model.fonts.find({name : fontName});
        }
        else
        if (this._textEditor.empty && this.data.font_family)
            font = this.model.fonts.find({id : this.data.font_family});
        
        return font ? font : this.model.fonts.getItemAt(0);
    }

    get fontFamily()
    {
        return this.font.id;
    }

    get textColor()
    {
        if (this._textEditor)
            return this._textEditor.color;
        else
            return this.data ? this.data.text_color : "";

    }

    get fontSizeLabel()
    {
        let size = parseInt( (this._textEditor && this._textEditor.size) ? this._textEditor.size : this.fontSize );
        return Math.round(size * 2);
    }


    
    get fontBold()
    {
        if (this._textEditor)
            return this._textEditor.bold;
    }

    get fontItalic()
    {
        if (this._textEditor)
            return this._textEditor.italic;
    }

    get alignLeft()
    {
        if (this._textEditor)
            return (!this._textEditor.align || this._textEditor.align == "left");
    }

    get alignCenter()
    {
        if (this._textEditor)
            return this._textEditor.align == "center";
    }

    get alignRight()
    {
        if (this._textEditor)
            return this._textEditor.align == "right";
    }

    get alignEnabled()
    {
        return this.data.content_type != "slice-text";
    }

    get fontSizeEnabled()
    {
        return this.data.content_type != "slice-text";
    }

    get acceptedSize()
    {
        return this._acceptedSize;
    }

    get boldEnabled()
    {
        let enabled = true;
        let fonts = this._textEditor.currentFontFamilies;
        for (let i = 0 ; i < fonts.length && enabled; i++)
        {
            let f = this.model.fonts.find({name : fonts[i]});
            enabled = enabled && f.bold;
        }
        
        return enabled;

        //return this.font.bold;
    }

    get italicEnabled()
    {
        let enabled = true;
        let fonts = this._textEditor.currentFontFamilies;
        for (let i = 0 ; i < fonts.length && enabled; i++)
        {
            let f = this.model.fonts.find({name : fonts[i]});
            enabled = enabled && f.italic;
        }
            
        
        return enabled;

        //return this.font.italic;
    }

 

    contextMenu(e)
    {
        let applyMenu = true;

        if (this._textEditor)
            applyMenu = this._textEditor.active ? "default" : false;
        
        return applyMenu;
    }

    /****************** Actions *********************/
    
    selectAll()
    {
        this._textEditor.selectAll();
    }

    unSelectAll()
    {
        this._textEditor.unSelectAll();
    }

    onFontFamily(font)
    {
        this._loadFont( font, true );
    }
    
    _onFontFamilyLoaded(font)
    {
        /*if (!this.active)
            this.selectAll();*/

        this._textEditor.fontFamily = font.name;
        
        this.data.event("font-family-updated", font.id);

        if (!this.active || this._textEditor.selection.noselection)
            this.data.font_family = font.id;

        if (!this.boldEnabled)
            this._textEditor.bold = false;
        
        if (!this.italicEnabled)
            this._textEditor.italic = false;
        
        this.resizeText();
    }


    onFontSizeInOut(value)
    {
        if (value == "up")
            this.onFontSizeIn();
        else
            this.onFontSizeOut();
    }

    onFontSizeIn()
    {
        this._textEditor.size = "+";

        if (this.data.content_type == "text")
            this.data.event("font-size-updated", this._textEditor.size);

        if (!this.active || this._textEditor.selection.noselection)
            this.data.font_size = this._textEditor.size;
    }

    onFontSizeOut()
    {
        this._textEditor.size = "-";

        if (this.data.content_type == "text")
            this.data.event("font-size-updated", this._textEditor.size);

        if (!this.active || this._textEditor.selection.noselection)
            this.data.font_size = this._textEditor.size;
    }

    onFontBold()
    {    
        /*if (!this.active)
            this.selectAll();*/

        this._textEditor.bold = "!";
    }

    onFontItalic()
    {
        /*if (!this.active)
            this.selectAll();*/

        this._textEditor.italic = "!";
    }


    onSetAlignLeft()
    {
        /*if (!this.active)
            this.selectAll();*/

        this._textEditor.align = "";

        if (this.data.content_type == "text")
            this.data.event("align-updated", "left");

        /*if (!this.active || this._textEditor.selection.noselection)
            this.data.align = "left";*/

    }
    
    onSetAlignCenter()
    {
        /*if (!this.active)
            this.selectAll();*/

        this._textEditor.align = "center";

        if (this.data.content_type == "text")
            this.data.event("align-updated", "center");

        /*if (!this.active || this._textEditor.selection.noselection)
            this.data.align = "center";*/
   
    }

    onSetAlignRight()
    {
        /*if (!this.active)
            this.selectAll();*/

        this._textEditor.align = "right";

        if (this.data.content_type == "text")
            this.data.event("align-updated", "right");

        /*if (!this.active || this._textEditor.selection.noselection)
            this.data.align = "right";*/

    }

    onTextColor(color)
    {
        /*if (!this.active)
            this.selectAll();*/

        this._textEditor.color = color;

        this.model.customcolors.addColor( color, this.model.creation.id );

        //this.data.event("font-color-updated", color);
        if (!this.active || this._textEditor.selection.noselection)
            this.data.text_color = color;
    }

    onBackgroundColor(color)
    {
        //this._textEditor.color = color;

        if (this.data.content_type == "slice-text")
            this.data.event("update-background-color", color);
        else
            this.data.bgcolor = color; 
        
        this.model.customcolors.addColor( color, this.model.creation.id );
    }

    updateCommands()
    {
        super.updateCommands();

        //this.command("backgroundcolor", "visible" , (this.data.content_type != "slice-text"));
    }

    /***************************************/

    create()
    {	
        super.create();
        
		//this.SVGElement = this.baseSVG.group()
							//.attr("class",this.classNames);
        
        //this._backgroundRect = this.SVGElement.rect();

        //this._backgroundRect = new fx.components.Box();
        this._textArea = new fx.components.Box();
        

        //this.addChild( this._backgroundRect );
        this.addChild( this._textArea /*, {width : "100%", height : "100%"}*/ );
        
        
        
        //this._calculateTextSize();

        //this._updateOverlay();
    }

    // only for mobile
    onEdit()
    {
        if (fx.browser.isMobile || fx.browser.isTablet)
        {
            //this.popup(new shared.popups.EditTextPopup(this.data));
    
            //this.data.event("edit-text", { force: false, component : this, textOutside : this._textOutside});
    
            // if warning, premiere fois afficher l'autre popup
            // sinon :
           //if (fx.get("EditTextPopup"))
            //{
            //    fx.get("EditTextPopup").show(this.data, true);
            //}
        }
        else
            this._textEditor.active = true;
    }

    onDataEvent(e)
    {
        if (e.type == "text-outside")
        {
            this._textOutside = true;
            this.addPositionWarning(e.detail.corrected, e.detail.warningPosition);
        }
        else if (e.type == "text-inside")
        {
            this._textOutside = false;
            this.removePositionWarning();
        }
        else if (e.type == "drag-over")
        {
            
        }
    }
    
    onDataUpdated(action)
    {
        super.onDataUpdated(action);
        
        if (action.type == "init")
        {
            this.editable = (this.data.content_type != "slice-text");
           // this.showActions = ((fx.browser.isMobile || fx.browser.isTablet) || this.data.content_type != "slice-text");
           this.showActions = (this.data.content_type != "slice-text");
            
            this.attr("data-id", this.data.id);
            this.attr("data-drop-allowed", (this.data.content_type != "slice-text"));
            //this._textArea.attr("data-id", this.data.id);
            this._textArea.addClass("text");

            if (this.data.content_type == "slice-text")
                this._textArea.addClass("slice-text");

            this.updateBorder();
							                        
            this.css("background-color" , this.data.bgcolor || 'rgba(255, 255, 255, 0)' )
            
            this._textEditor = new fx.components.TextEditor(this._textArea.node, null, this.model.fonts);

            if (this.data.content)
                this._textEditor.setHTML(this.data.content);

            this._updateDefaultStyle();

            this.on('editor-change', this._onPathChange, this._textEditor );
            this.on('selection-change', this._onPathChange, this._textEditor );
            this.on('text-change', this._onTextInput, this._textEditor );
            this._loadFonts();
            
            this._calculateTextSize();

            if (this.data.height_inner == -1)
                this.resizeText();

            this._textEditor.selectAll();

            this.data.event("text-size-updated", true);
        }
        
        if (action.impacts("side") || action.impacts("borderid"))
            this.updateBorder();
        
        if (action.impacts("bgcolor"))
            this.css("background-color" , this.data.bgcolor || 'rgba(255, 255, 255, 0)' )

        if (action.impacts("content") && action.tag == "drop")
        {
            /*if (action.history)
            {
                this.data.update({content : action.data.content, width : action.data.width, height : action.data.width});
            }
            else
            {
                let text = fx.get("texts").find({id : action.data.content});
                if (text)
                    this.data.update({content : text.content, width : text.width, height : text.width});
            }*/

            this._textEditor.setHTML( this.data.content );
            this.resizeText();
            this._updateOverlay();
        }
        else
        if (action.tag == "update-content" || ( action.impacts("content") && action.history) )
        {
            this._textEditor.setHTML( this.data.content );
            this.resizeText();
            this._updateOverlay();
        }

      

        if (action.impacts("font_family", "font_size", "text_color", "align"))
            this._updateDefaultStyle();
            
        if (action.impacts("id"))
            this.attr("data-id", this.data.id);
    }

    

    _updateDefaultStyle()
    {
        let font = this.model.fonts.find({id : this.data.font_family || 1 });
        if (!font)
            font = this.model.fonts.find({id :  1 });
        
        if (this.emptyText)
        {
            this.emptyText.css({"font-family" : font ? font.name : "Open Sans", color : this.data.text_color});
            this._updateOverlay();
        }
            
        
        this._textEditor.setDefaultStyle( { "font-family"  :    font ? font.name : "Open Sans", 
                                                                "font-size"    :  this.data.font_size,
                                                                "text-align"   :  "left" }, 
                                                        this.data.content_type == "slice-text" );
    }



    onBorder(data)
    {
        this.data.update({borderid : data.thickness, side : data.color})

        this.model.customcolors.addColor( data.color, this.model.creation.id );
    }

    resize(width, height , side)
    {
        let ret = super.resize(width, height , side);

        if (ret)
        {
            this._updateOverlay();
            this._calculateTextSize();
        }

        return ret;
    }

    moveStart()
    {
		super.moveStart();
		
		if ( tinycolor(this.component.bgcolor).getAlpha() == 0)
			this.css("background-color", "rgba(0,0,0,0.1)");
	}
	
	moveEnd()
    {
		super.moveEnd();
		if ( this.component && tinycolor(this.component.bgcolor).getAlpha() == 0)
			this.css("background-color", "");
    }

    get minComponentSize()
    {
        return  {
            height : this._acceptedSize ? this._acceptedSize.height : this.MARGINS*2,
            width : this.MARGINS*2
        }
    }

    get toolTip()
    {
        return (this.data && this.data.content_type == "slice-text") ?  (this.model.creation.hasSlice ? fx.text("Cliquez pour personnaliser la tranche") : fx.text("L'ajout de texte sur la tranche n'est possible qu'avec une couverture rigide, ou avec plus de 40 pages.")) : super.toolTip;
    }

    set toolTip(val)
    {
        super.toolTip = val;
    }

    activate(val)
    {        
        if (val && this.model.zoom.value < 100)
            return;

        if (!this._textEditor || !this.editable)
            return;

        if (val)
        {
            if (!this._preactivate)
                this._preactivate = true;
            else
            {
                super.activate(true);
                this.onEdit();
            }
        }
        else
        {
            super.activate(false);
            this._preactivate = false;
            this._textEditor.active = false;
        }

        this._updateOverlay();

    }

	_onPathChange()
    {
        // used to update toolbar buttons state
        this.trigger("selection-changed");
    }
    
    // content changed, need to resize the component
    _onTextInput(e)
    {
        this.resizeText();
        this.trigger("selection-changed");
    }
    
    resizeText()
    {
        let update = {};

        if (this.data.content != this._textEditor.innerHTML)
            update.content = this._textEditor.innerHTML;
        
        this._calculateTextSize();
            
        if (this.data.width != this._acceptedSize.width || this.data.height != this._acceptedSize.height)
        {
            let newWidth = this._acceptedSize.width;
            let newHeight = this._acceptedSize.height;
        
            if (newWidth != this.data.width || newHeight != this.data.height)
            {
                update.width = newWidth;
                update.height = newHeight;


                //this.trigger("size-updated");
                this.data.event("text-size-updated");
            }
        }
        
        this.data.update(update.content ? "" : "resize-text", update);

        this._updateOverlay();
    }

    _calculateTextSize()
    {
        let paragraphs = this.find("p");

        if (paragraphs == null)
            paragraphs = [];
        else
        if (!( paragraphs instanceof Array) )
            paragraphs = [paragraphs];
      
        let calculatedHeight = this.MARGINS;

        for (let i = 0; i < paragraphs.length; i++)
            calculatedHeight += fx.dom.outerHeight( paragraphs[i]);
        
        this._acceptedSize = {width : this.data.width , height : calculatedHeight};
    }

    singleLineHeight()
    {
        let paragraphs = this.find("p");
        if (paragraphs == null || paragraphs.length == 0)
            return 0;

        if (!( paragraphs instanceof Array) )
            paragraphs = [paragraphs];

        return parseFloat(fx.dom.css(paragraphs[0],"line-height"));
    }

   
   /**
    * Create / removes / position overlay elements : empty text, loading font animation
    */ 
    _updateOverlay()
    {
        if (!this._textArea)
            return;

        //----- Check if empty
        if (this.empty && !this._textEditor.active)
        {
            if (!this.emptyText)
                this.emptyText = new fx.components.Text({text : this.data.contentLabel(), className : "empty-text"});
            
            this.emptyText.visibleAtStart = fx.get("app") != "screenshot";
            
            if (!this.hasChild( this.emptyText ))
                this.addChild( this.emptyText, {top : "center", left : "center", width : "100%", height : "auto"});

            if (this.data.font_family)
            {
                let font = this.model.fonts.find({id : this.data.font_family});
                if (font)
                   this.emptyText.css({"font-family" : font.name, color : this.data.text_color});
            }
            
        }
        else
        {
            if (this.emptyText && this.hasChild(this.emptyText))
                this.removeChild( this.emptyText)
        }    

        if (fx.get("app") != "screenshot")
            this.delay( this._loadingFondAnimate, 50);       
    }

    _loadingFondAnimate()
    {
        // check if font is loading
        if (this._loadingFonts && this._loadingFonts.length > 0)
        {
            this._textArea.css("opacity" , 0.3);

            if (!this._loadingFontAnimation)
            {
                this._loadingFontAnimation = new fx.components.Image( {data : fx.get("assets").loader, className : "loading-font"} );
                this.addChild(this._loadingFontAnimation, {top:"center", left : "center", width : 10, height: 10});
            }
        }
        else
        {
            if (this._textArea)
                this._textArea.css("opacity" , 1);

            if (this._loadingFontAnimation)
            {
                this._loadingFontAnimation.destroy();
                this._loadingFontAnimation = null;
            }
        } 
    }


    onDisplayUpdated()
    {
        super.onDisplayUpdated();
        
        if (this._textArea)
            this._textArea.css({width : this.data.width - this.MARGINS, height : "inherit",/*height : this.data.height - this.MARGINS,*/ top : this.MARGINS / 2, left : this.MARGINS / 2});
            

        this._updateWarning();
    }

    /**
     * This function allows to display warning on Text component about lost border
     * @param {Boolean} val 
     */
    addPositionWarning(correction , warningPosition)
    {
        if (this.preview || this.data.content_type == "slice-text")
            return;

        if(fx.browser.isMobile)
        {
            this._warning = true;
            if (!this._borderWarning)
            {
                this._borderWarning = new fx.components.Image(fx.get("assets").warningIcon);
                if (warningPosition == "right")
                    this.addChild(this._borderWarning, {width : 22, height : 19, right : -22, top : "center"});
                else if(warningPosition == "left")
                    this.addChild(this._borderWarning, {width : 22, height : 19, left : -22, top : "center"});
                else if (warningPosition == "bottom")
                    this.addChild(this._borderWarning, {width : 22, height : 19, left : "center", bottom : -22});
                else if (warningPosition == "top")
                    this.addChild(this._borderWarning, {width : 22, height : 19, left : "center", top : -22});
                else
                    this.addChild(this._borderWarning, {width : 22, height : 19, left : "center", top : "center"});
            }
        }
        else{
            this.showWarning(correction, fx.text("Ce bloc texte est trop proche du bord. Déplacez-le ou réduisez-le pour qu'il ne soit pas coupé lors de la fabrication."));
        }
        //this.delay(this.showWarning, 5000);
    }

    displayWarningPopup(e){
        this.popup(new mobile.common.popups.TextOverflowPopup());
    }

    removePositionWarning(){
        this._warning = false;
        this.removeChild(this._borderWarning);
        this._borderWarning = null;
    }

    destroy()
    {
        super.destroy();
        
        /*if (this.emptyText)
            this.emptyText.remove(); 
        
        if (this._animationFontInner)
            this._animationFontInner.remove();
        
        if(this._loadingFontAnimation)
            this._loadingFontAnimation.remove();

        if (this._backgroundRect)
            this._backgroundRect.remove();

        if (this._textContainer)
            this._textContainer.remove();*/

        if (this._textEditor)
            this._textEditor.destroy();
    }

    _loadFonts()
    {
        let fonts = this._textEditor.allFontFamilies;

        if (this.model.creation.last_font_family)
        {
            let font = this.model.fonts.find({id : this.model.creation.last_font_family})
            if (font)
                fonts.push( font )
        }

        let fontsLoading = [];
        for (let i = 0; i < fonts.length; i++)
        {
            let font = this._fontService.getFont( fonts[i] );
            if (!font.loaded && !font.loading)
            {
                fontsLoading.push(font);
                this._loadFont( font);
            }
        }

        if (fontsLoading.length == 0)
        {
            this._updateOverlay();
            this.data.event("fonts-loaded");
        }
    }

    _loadFont(font, select)
    {
        if (select)
            this._selectedFont = font;

        this.on("loaded", this._onFontLoaded, font );
        this.on("error", this._onFontError, font );
        
        this._loadingFonts.push(font);
        
        this._updateOverlay();

        this._fontService.load( font );
    }

    _onFontLoaded(e)
    {
        let font = e.detail;

        this.off("loaded", this._onFontLoaded, font );
        this.off("error", this._onFontError, font );

        if (!this._loadingFonts) return;

        this._loadingFonts.remove( font );
        
        this._updateOverlay();

        if (this._selectedFont == font)
        {
            this._selectedFont = null;
            this._onFontFamilyLoaded(font);
        }

        if (this._loadingFonts.length == 0)
            this.data.event("fonts-loaded");
            
    }

    _onFontError(e)
    {
        let font = e.detail;

        this.off("loaded", this._onFontLoaded, font );
        this.off("error", this._onFontError, font );

        if (!this._loadingFonts) return;

        this._loadingFonts.remove( font );
        
        this._updateOverlay();

        this._disableFont(font);

        if (this._loadFontTries < 3)
        {
            //this._loadFontTries++;
            //this._loadFont(font);
            this.delay(this._loadFonts);
        }
        else
        {
            this.data.event("font-loaded-error", {error : "font-loaded-error", details : font.name});
        }
    
    }

    _disableFont(font)
    {
        // TODO
        if (this._fontService)
            this._fontService.disableFont( font );
    }

    

});
